// Generated by ReScript, PLEASE EDIT WITH CARE

import * as T from "common/src/T.bs.js";
import * as Caml from "rescript/lib/es6/caml.js";
import * as Data from "common/src/data/Data.bs.js";
import * as Link from "../Link.bs.js";
import * as CssJs from "bs-css-emotion/src/CssJs.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as Patch from "common/src/Patch.bs.js";
import * as Route from "../Route.bs.js";
import * as Share from "../common/Share.bs.js";
import * as React from "react";
import * as LlIcon from "../components/LlIcon.bs.js";
import * as Region from "common/src/Region.bs.js";
import * as TftSet from "common/src/data/TftSet.bs.js";
import * as Js_dict from "rescript/lib/es6/js_dict.js";
import * as Js_math from "rescript/lib/es6/js_math.js";
import * as PlUtils from "../player/PlUtils.bs.js";
import * as Tooltip from "common/src/components/Tooltip.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as ScreenAtom from "common/src/atoms/ScreenAtom.bs.js";
import * as TraitTeam2 from "../components/TraitTeam2.bs.js";
import * as ApertureCtx from "../ctx/ApertureCtx.bs.js";
import * as Belt_Option from "rescript/lib/es6/belt_Option.js";
import * as Caml_option from "rescript/lib/es6/caml_option.js";
import * as AugmentImage from "common/src/tft-static/AugmentImage.bs.js";
import * as LpChartUtils from "common/src/LpChartUtils.bs.js";
import * as PlLegendLevel from "../components/PlLegendLevel.bs.js";
import * as Belt_SortArray from "rescript/lib/es6/belt_SortArray.js";
import * as PositionSquare from "../player/PositionSquare.bs.js";
import Format from "date-fns/format";
import * as UnitImageExtended from "common/src/tft-static/UnitImageExtended.bs.js";
import Close from "@mui/icons-material/Close";

function PlMatchDetails$ParticipantRow(Props) {
  var matchInfo = Props.matchInfo;
  var region = Props.region;
  var participant = Props.participant;
  var companionId = Props.companionId;
  var traits = Props.traits;
  var set = TftSet.use(undefined);
  React.useContext(TftSet.ctx);
  ScreenAtom.use(undefined);
  var chosenTraits = React.useMemo((function () {
          return PlUtils.getHeadlinerTraits(participant, set);
        }), [
        participant,
        set
      ]);
  var boardValue = String(PlUtils.calcBoardValue(participant.units, set));
  var augments = participant.augments;
  var tmp;
  if (augments !== undefined) {
    var rangeStart = augments.length === 2 && participant.lastRound >= 20 ? -1 : 0;
    tmp = Belt_Array.map(Belt_Array.range(rangeStart, rangeStart + 2 | 0), (function (idx) {
            var augId = Belt_Array.get(augments, idx);
            if (augId !== undefined) {
              return React.createElement(AugmentImage.make, {
                          augId: Data.encodeAugmentId(augId),
                          size: 34,
                          sizeLg: 36,
                          key: augId
                        });
            } else {
              return React.createElement("div", {
                          key: String(idx),
                          className: "w-[34px] lg:w-[36px]"
                        });
            }
          }));
  } else {
    tmp = null;
  }
  return React.createElement(React.Fragment, undefined, React.createElement("div", {
                  className: "flex items-center w-auto"
                }, React.createElement(PositionSquare.make, {
                      className: "mr-2 lg:ml-1",
                      size: 34,
                      pl: participant.placement,
                      queueId: matchInfo.info.queueId
                    }), React.createElement("div", {
                      className: "w-[104px] mx-2"
                    }, React.createElement("a", {
                          className: "block truncate notranslate text-sm leading-snug lg:text-base lg:leading-snug",
                          href: Route.toString({
                                TAG: /* Player */2,
                                _0: {
                                  region: region,
                                  playerName: participant.name,
                                  tag: participant.tag,
                                  match: undefined
                                }
                              })
                        }, participant.name), Belt_Option.mapWithDefault(Js_dict.get(matchInfo.ranks, participant.name), null, (function (rank) {
                            return React.createElement("div", {
                                        className: "pt-[1px] text-white2 text-xs font-medium"
                                      }, LpChartUtils.renderDivisionName(rank[0]) + " " + String(rank[1]) + "lp");
                          }))), React.createElement(PlLegendLevel.make, {
                      className: "ml-1 mr-3",
                      companionId: companionId,
                      level: participant.level
                    }), React.createElement("div", {
                      className: "flex items-center font-montserrat font-medium"
                    }, React.createElement("div", {
                          className: "w-[30px] flex justify-center mx-2 mr-3 truncate"
                        }, matchInfo.info.queueId === 1130 ? T.renderHyperrollStageNumber(participant.lastRound) : T.renderStageNumber(participant.lastRound)), React.createElement("div", {
                          className: "w-[42px] flex sm:flex-col mr-4 truncate text-[14px] font-medium"
                        }, React.createElement(Tooltip.make, {
                              title: boardValue + " final board gold value",
                              children: React.createElement("div", {
                                    className: "flex items-center justify-end"
                                  }, boardValue, React.createElement("img", {
                                        className: "ml-[3px]",
                                        height: "13",
                                        src: "https://cdn.tft.tools/general/gold.png?width=13",
                                        width: "13"
                                      }))
                            }), React.createElement(Tooltip.make, {
                              title: String(participant.totalDamageToPlayers) + " damage dealt to players",
                              children: React.createElement("div", {
                                    className: "flex items-center justify-end ml-3 sm:ml-0 sm:mt-1"
                                  }, String(participant.totalDamageToPlayers), React.createElement("img", {
                                        className: "ml-[3px]",
                                        height: "12",
                                        src: "https://cdn.tft.tools/general/announce_icon_combat.png?width=12",
                                        width: "12"
                                      }))
                            }))), React.createElement(TraitTeam2.make, {
                      traits: traits,
                      chosenTraits: chosenTraits,
                      className: "hidden lg:block ml-2 mr-3"
                    }), React.createElement("div", {
                      className: "ml-auto flex gap-[6px] lg:ml-0 lg:pr-6"
                    }, tmp)), React.createElement("div", {
                  className: CssJs.merge([
                        "grid gap-1 gap-y-5 sm:gap-[9px] ml-auto sm:ml-0 pt-[18px] sm:pt-5 lg:pt-0 sm:pb-1 lg:pb-0",
                        CssJs.style([
                              CssJs.gridTemplateColumns([{
                                      NAME: "repeat",
                                      VAL: [
                                        {
                                          NAME: "num",
                                          VAL: Caml.caml_int_min(participant.units.length, 9)
                                        },
                                        CssJs.px(32)
                                      ]
                                    }]),
                              T.sm_([CssJs.gridTemplateColumns([{
                                            NAME: "repeat",
                                            VAL: [
                                              {
                                                NAME: "num",
                                                VAL: Caml.caml_int_min(participant.units.length, 10)
                                              },
                                              CssJs.px(43)
                                            ]
                                          }])])
                            ])
                      ])
                }, Belt_Array.mapWithIndex(Belt_Array.keep(participant.units, (function (u) {
                            return ![
                                      "TFT_TrainingDummy",
                                      "TFT7_TrainerDragon",
                                      "TFT7_JadeStatue",
                                      "TFT9_THex",
                                      "TFT9_HeimerdingerTurret",
                                      "TFT12_Yuumi",
                                      "TFT_ElderDragon",
                                      "TFT12_WinterStatue"
                                    ].includes(u.id);
                          })), (function (idx, u) {
                        var unitId = Data.fixId(u.id);
                        try {
                          return React.createElement(UnitImageExtended.make, {
                                      size: 32,
                                      sizeSm: 43,
                                      unitId: unitId,
                                      starLevel: u.tier,
                                      items: u.items2,
                                      key: String(idx)
                                    });
                        }
                        catch (exn){
                          return null;
                        }
                      }))));
}

var make = React.memo(PlMatchDetails$ParticipantRow);

var ParticipantRow = {
  make: make
};

function PlMatchDetails$ParticipantRowMobile(Props) {
  var matchInfo = Props.matchInfo;
  var region = Props.region;
  var participant = Props.participant;
  var isHero = Props.isHero;
  var set = TftSet.use(undefined);
  React.useContext(TftSet.ctx);
  var boardValue = String(PlUtils.calcBoardValue(participant.units, set));
  var augments = participant.augments;
  var tmp;
  var exit = 0;
  if (augments !== undefined && augments.length !== 0) {
    tmp = React.createElement("div", {
          className: "ml-auto flex mr-[10px]"
        }, Belt_Array.mapWithIndex(augments, (function (idx, augId) {
                return React.createElement("div", {
                            key: augId,
                            className: "mx-[2px]"
                          }, React.createElement(AugmentImage.make, {
                                augId: Data.encodeAugmentId(augId),
                                size: 20
                              }));
              })));
  } else {
    exit = 1;
  }
  if (exit === 1) {
    tmp = React.createElement("div", {
          className: "ml-auto w-[100px]"
        });
  }
  return React.createElement("div", {
              className: "flex w-full"
            }, React.createElement("div", {
                  className: "flex flex-col items-center pt-[1px] mr-[9px]"
                }, React.createElement(PositionSquare.make, {
                      size: 22,
                      pl: participant.placement,
                      queueId: matchInfo.info.queueId
                    }), React.createElement("div", {
                      className: "relative my-[6px] mx-[6px]"
                    }, React.createElement("div", {
                          className: "w-[21px] h-[21px]"
                        }, React.createElement(LlIcon.make, {
                              companionId: participant.companionId,
                              size: 21
                            })), React.createElement("div", {
                          className: "absolute bottom-[-4px] right-[-7px] text-[13px] w-[19px] h-[19px] text-center font-medium text-center flex items-center justify-center rounded-full border border-white1 bg-[#00000050]"
                        }, String(participant.level))), React.createElement("div", {
                      className: "w-8 text-xs text-center font-medium truncate"
                    }, matchInfo.info.queueId === 1130 ? T.renderHyperrollStageNumber(participant.lastRound) : T.renderStageNumber(participant.lastRound))), React.createElement("div", {
                  className: "flex-1"
                }, React.createElement("div", {
                      className: "flex items-center w-full sm:w-auto h-5"
                    }, React.createElement("div", {
                          className: (
                            isHero ? "font-medium " : ""
                          ) + "mr-2 w-[85px]"
                        }, React.createElement(Link.make, {
                              route: {
                                TAG: /* Player */2,
                                _0: {
                                  region: region,
                                  playerName: participant.name,
                                  tag: participant.tag,
                                  match: undefined
                                }
                              },
                              children: React.createElement("div", {
                                    className: "truncate notranslate text-xs"
                                  }, participant.name)
                            })), Belt_Option.mapWithDefault(Js_dict.get(matchInfo.ranks, participant.name), null, (function (rank) {
                            return React.createElement("div", {
                                        className: "w-[44px] text-white2 pt-[1px]"
                                      }, React.createElement("div", {
                                            className: "font-medium text-[10px] sm:text-xs leading-snug"
                                          }, LpChartUtils.renderDivisionNameShort(rank[0]) + " " + String(rank[1]) + "lp"));
                          })), React.createElement("div", {
                          className: "flex mx-2 truncate text-xs leading-none ml-auto"
                        }, React.createElement(Tooltip.make, {
                              title: boardValue + " final board gold value",
                              children: React.createElement("div", {
                                    className: "flex items-center justify-end w-[32px]"
                                  }, React.createElement("div", {
                                        className: "pr-[2px]"
                                      }, boardValue), React.createElement("img", {
                                        height: "11",
                                        src: "https://cdn.tft.tools/general/gold.png?width=11",
                                        width: "11"
                                      }))
                            }), React.createElement(Tooltip.make, {
                              title: String(participant.totalDamageToPlayers) + " damage dealt to players",
                              children: React.createElement("div", {
                                    className: "flex items-center justify-end w-[32px] ml-1"
                                  }, React.createElement("div", {
                                        className: "pr-[1px]"
                                      }, String(participant.totalDamageToPlayers)), React.createElement("div", undefined, React.createElement("img", {
                                            height: "11",
                                            src: "https://cdn.tft.tools/general/announce_icon_combat.png?width=11",
                                            width: "11"
                                          })))
                            })), tmp), React.createElement("div", {
                      className: "grid gap-[3px] xs:gap-1 gap-y-[18px] xs:gap-y-4 pt-3 pb-[8px] grid-cols-[repeat(9,32px)]"
                    }, Belt_Array.mapWithIndex(Belt_Array.keep(participant.units, (function (u) {
                                return ![
                                          "TFT_TrainingDummy",
                                          "TFT7_TrainerDragon",
                                          "TFT7_JadeStatue",
                                          "TFT9_THex",
                                          "TFT9_HeimerdingerTurret",
                                          "TFT12_Yuumi",
                                          "TFT_ElderDragon",
                                          "TFT12_WinterStatue"
                                        ].includes(u.id);
                              })), (function (idx, u) {
                            var unitId = u.id.startsWith("TFT9_Ryze") ? "TFT9_Ryze" : Data.fixId(u.id);
                            try {
                              return React.createElement(UnitImageExtended.make, {
                                          size: 32,
                                          sizeSm: 43,
                                          sizeMd: 43,
                                          unitId: unitId,
                                          starLevel: u.tier,
                                          items: u.items2,
                                          key: String(idx)
                                        });
                            }
                            catch (exn){
                              return null;
                            }
                          })))));
}

var make$1 = React.memo(PlMatchDetails$ParticipantRowMobile);

var ParticipantRowMobile = {
  make: make$1
};

function PlMatchDetails$Header(Props) {
  var matchInfo = Props.matchInfo;
  var noShare = Props.noShare;
  var heroName = Props.heroName;
  var heroTag = Props.heroTag;
  var screenSize = ScreenAtom.use(undefined);
  var duration = Js_math.floor_int(matchInfo.info.duration);
  return React.createElement("div", {
              className: "flex pl-5 pb-4 pr-14 gap-6 sm:gap-8 md:gap-10 flex-wrap sm:items-center text-sm sm:text-base leading-none sm:leading-none border-b-2 border-primary-11"
            }, React.createElement("div", {
                  className: "flex flex-col gap-[5px]"
                }, React.createElement("div", {
                      className: "text-white2"
                    }, "Patch"), React.createElement("div", {
                      className: "font-montserrat font-semibold"
                    }, Patch.render(matchInfo.info.patch))), React.createElement("div", {
                  className: "flex flex-col gap-[5px]"
                }, React.createElement("div", {
                      className: "text-white2"
                    }, "Date"), React.createElement("div", {
                      className: "font-montserrat font-semibold"
                    }, Format(new Date(matchInfo.info.dateTime), "MMM d HH:mm"))), React.createElement("div", {
                  className: "flex flex-col gap-[5px]"
                }, React.createElement("div", {
                      className: "text-white2"
                    }, "Duration"), React.createElement("div", {
                      className: "font-montserrat font-semibold"
                    }, String(duration / 60 | 0) + ":" + (
                      duration % 60 < 10 ? "0" : ""
                    ) + String(duration % 60))), React.createElement("div", {
                  className: "flex flex-col gap-[5px] pr-4"
                }, React.createElement("div", {
                      className: "text-white2"
                    }, "Mode"), React.createElement("div", {
                      className: "font-montserrat font-semibold"
                    }, PlUtils.queueName(matchInfo.info.queueId))), noShare ? null : React.createElement(Share.Button.make, {
                    forceFull: screenSize !== /* Sm */4,
                    url: "https://tactics.tools/" + Route.toString({
                          TAG: /* Player */2,
                          _0: Belt_Option.map(heroName, (function (heroName) {
                                  return {
                                          region: Region.fromApiName(Belt_Array.getExn(matchInfo.id.split("_"), 0).toLowerCase()),
                                          playerName: heroName,
                                          tag: heroTag,
                                          match: matchInfo.id
                                        };
                                }))
                        }),
                    size: "medium"
                  }));
}

var Header = {
  make: PlMatchDetails$Header
};

function PlMatchDetails$Inner(Props) {
  var region = Props.region;
  var matchInfo = Props.matchInfo;
  var heroName = Props.heroName;
  var heroTag = Props.heroTag;
  var onClose = Props.onClose;
  var noShareOpt = Props.noShare;
  var noShare = noShareOpt !== undefined ? noShareOpt : false;
  ApertureCtx.useValue(undefined);
  var screenSize = ScreenAtom.use(undefined);
  var rows = Belt_SortArray.stableSortBy(matchInfo.info.participants, (function (a, b) {
          return Caml.caml_int_compare(a.placement, b.placement);
        }));
  return React.createElement("div", {
              className: "px-0 overflow-x-hidden max-h-[100%] overflow-y-auto w-screen max-w-[380px] sm:w-auto sm:max-w-[100vw] py-5 lg:overflow-x-auto lg:relative",
              id: "player-match-summary"
            }, React.createElement("div", {
                  className: "ss-hidden absolute right-[14px] top-[16px] cursor-pointer p-1 rounded-full z-10",
                  onClick: (function (param) {
                      return Curry._1(onClose, undefined);
                    })
                }, React.createElement("div", {
                      className: "p-[5px] rounded-full bg-[#33333377]"
                    }, React.createElement(Close, {}))), React.createElement(PlMatchDetails$Header, {
                  matchInfo: matchInfo,
                  noShare: noShare,
                  heroName: heroName,
                  heroTag: heroTag
                }), React.createElement("div", {
                  className: "grid gap-[2px] sm:gap-2"
                }, Belt_Array.mapWithIndex(rows, (function (idx, participant) {
                        var isHero = Belt_Option.mapWithDefault(heroName, false, (function (heroName) {
                                return PlUtils.reducePlayerName(participant.name) === heroName;
                              }));
                        var match = matchInfo.info.queueId;
                        var placement = match !== 1150 && match !== 1160 ? participant.placement : (participant.placement + 1 | 0) / 2 | 0;
                        var bgColor;
                        switch (placement) {
                          case 1 :
                              bgColor = "bg-[#F1C55522]";
                              break;
                          case 2 :
                              bgColor = "bg-[#DC38C322]";
                              break;
                          case 3 :
                              bgColor = "bg-[#6ECCFF22]";
                              break;
                          case 4 :
                              bgColor = "bg-[#37D48822]";
                              break;
                          case 5 :
                          case 6 :
                          case 7 :
                          case 8 :
                              bgColor = "bg-[#BBBBBB22]";
                              break;
                          default:
                            throw {
                                  RE_EXN_ID: "Assert_failure",
                                  _1: [
                                    "PlMatchDetails.res",
                                    445,
                                    19
                                  ],
                                  Error: new Error()
                                };
                        }
                        var borderColor;
                        switch (placement) {
                          case 1 :
                              borderColor = "border-legendary-2";
                              break;
                          case 2 :
                              borderColor = "border-epic-2";
                              break;
                          case 3 :
                              borderColor = "border-rare-2";
                              break;
                          case 4 :
                              borderColor = "border-uncommon-2";
                              break;
                          default:
                            borderColor = "border-common-2";
                        }
                        var borderl = placement <= 4 ? "border-l-[3px] " : "border-l-2";
                        var traits = Belt_Array.keepMap(participant.traits, (function (t) {
                                if (t.currentTier > 0) {
                                  return [
                                          t.name,
                                          t.currentTier
                                        ];
                                }
                                
                              }));
                        return React.createElement("div", {
                                    key: participant.name,
                                    className: CssJs.merge([
                                          idx === 0 ? "pt-[8px] sm:pt-[16px]" : "pt-[6px] sm:pt-[14px]",
                                          "flex flex-col justify-around items-start lg:flex-row lg:justify-start lg:items-center lg:h-auto pb-[8px] sm:pb-[14px] xs:px-[6px] sm:px-6 " + (
                                            isHero ? bgColor + " border-solid " + borderl + " " + borderColor : (
                                                idx % 2 === 0 ? "bg-bg2" : ""
                                              )
                                          )
                                        ])
                                  }, screenSize >= 5 ? React.createElement(make$1, {
                                          idx: idx,
                                          matchInfo: matchInfo,
                                          region: region,
                                          heroName: heroName,
                                          participant: participant,
                                          isHero: isHero,
                                          traits: traits,
                                          key: String(idx)
                                        }) : React.createElement(make, {
                                          idx: idx,
                                          matchInfo: matchInfo,
                                          region: region,
                                          heroName: heroName,
                                          participant: participant,
                                          isHero: isHero,
                                          companionId: participant.companionId,
                                          traits: traits,
                                          key: String(idx)
                                        }));
                      }))));
}

var make$2 = React.memo(PlMatchDetails$Inner);

var Inner = {
  make: make$2
};

function PlMatchDetails(Props) {
  var region = Props.region;
  var matchInfo = Props.matchInfo;
  var heroName = Props.heroName;
  var heroTag = Props.heroTag;
  var onClose = Props.onClose;
  var noShareOpt = Props.noShare;
  var noShare = noShareOpt !== undefined ? noShareOpt : false;
  var matchInfo$1 = T.removeMatchTempTraits(matchInfo);
  var tmp = {
    region: region,
    matchInfo: matchInfo$1,
    onClose: onClose,
    noShare: noShare
  };
  if (heroName !== undefined) {
    tmp.heroName = Caml_option.valFromOption(heroName);
  }
  if (heroTag !== undefined) {
    tmp.heroTag = Caml_option.valFromOption(heroTag);
  }
  var el = React.createElement(make$2, tmp);
  var set = TftSet.use(undefined);
  var match = matchInfo$1.info.queueId;
  if (match !== 6000) {
    if (match !== 6100) {
      if (match !== 6110) {
        return el;
      } else if (set === 140 || set === 14) {
        return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set101 */11, el, undefined));
      } else {
        return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set56 */9, el, undefined));
      }
    } else {
      return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set46 */10, el, undefined));
    }
  } else {
    return React.createElement(TftSet.Provider.make, TftSet.Provider.makeProps(/* Set36 */8, el, undefined));
  }
}

var make$3 = React.memo(PlMatchDetails);

export {
  ParticipantRow ,
  ParticipantRowMobile ,
  Header ,
  Inner ,
  make$3 as make,
  
}
/* make Not a pure module */
